import React, { useEffect, useState, useMemo } from "react";
import { Button, ButtonGroup, Card, Col, Container, Form, Row } from "react-bootstrap";
import Metadatx from "./Metadatx";
import Linetime from "./Linetime";
import Modaview from "./Modaview";
import {
  getCustomFilters,
  getFiltersTkr,
  setFiltersTkr,
  getReports,
  setCustomFilters,
  setCliidxx,
} from "../../libs/redux/slices/Trkgfile/trkgfileSlice";

import {
  useGetFiltersQuery,
  trkgfileApiSlice
} from "../../libs/redux/slices/Trkgfile/trkgfileApislice";
import { setDictionaryErrors } from "../../libs/redux/slices/errorSlice/errorSlice";
import { dictionaryErrors } from "./configxx";

import {
  useGetCompanysQuery,
  useGetProcesoQuery,
  useGetSerieQuery,
  useGetTiposQuery,
  useGetMetadatosQuery,
} from "../../libs/redux/slices/filterSlice/filterApiSlice";

import { useDispatch, useSelector } from "react-redux";
import Loadingx from "../Loadingx/Loadingx";
import InfiniteScroll from "react-infinite-scroll-component";
import CryptoJS from 'crypto-js';

const Selparxx = ({ onClose, EMPNITXX, AREAIDXX, TIPOIDXX, CLIIDXXX, parents, setFileParents }) => {
  const dispatch = useDispatch();
  dispatch(setDictionaryErrors({ dictionaryErrors }));

  const customFilters = useSelector(getCustomFilters);
  const { page, perPage, sorts } = customFilters;
  const [selAllChecked, setSelAllChecked] = useState([]);
  const [AllChecked, setAllChecked] = useState(false);
  const [checSelc, setChecSelc] = useState([]);
  const [dataTkr, setDatatkr] = useState([]);
  const [opMetada, setOpMetada] = useState(false);
  const [metadaSelc, setMetadaSelc] = useState("");
  const [linetime, setLinetime] = useState(false);
  const [lineData, setLineData] = useState("");
  const [metadaMaqSelc, setMetadaMaqSelc] = useState("");
  const reports = useSelector(getReports);
  const [selectedKey, setSelectedKey] = useState(0);
  const [dataEdit, setDataEdit] = useState(null);
  const [modalView, setModalView] = useState(false);
  const [jsonFilters, setJsonFilters] = useState("");
  const [currentImage, setCurrentImage] = useState("");

  const [filterEmpresa,  setFilterEmpresa]  = useState("");
  const [filterArea,     setFilterArea]     = useState("");
  const [filterSerie,    setFilterSerie]    = useState("");
  const [filterTipo,     setFilterTipo]     = useState("");
  const [filterMetadato, setFilterMetadato] = useState("");
  const [filterMetaVal,  setFilterMetaVal]  = useState("");

  const { data: companysData }  = useGetCompanysQuery();
  const { data: procesosData }  = useGetProcesoQuery();
  const { data: seriesData }    = useGetSerieQuery();
  const { data: tiposData }     = useGetTiposQuery();
  const { data: metadatosData } = useGetMetadatosQuery();

  const parentEmpnits  = useMemo(() => [...new Set(parents.map(r => r.EMPNITPA))].join(","), [parents]);
  const parentAreaids  = useMemo(() => [...new Set(parents.map(r => r.AREAIDPA))].join(","), [parents]);
  const parentTipoids  = useMemo(() => [...new Set(parents.map(r => r.TIPOIDPA))].join(","), [parents]);

  const parentCombos = useMemo(() => {
    const seen = new Set();
    return parents.filter(r => {
      const k = `${r.EMPNITPA}|${r.AREAIDPA}|${r.SERIEIPA}|${r.TIPOIDPA}`;
      if (seen.has(k)) return false;
      seen.add(k);
      return true;
    });
  }, [parents]);

  const [existingTipoIds, setExistingTipoIds]   = useState(() => new Set());
  const [existingSerieIds, setExistingSerieIds] = useState(() => new Set());

  useEffect(() => {
    if (!parentCombos.length) {
      setExistingTipoIds(new Set());
      setExistingSerieIds(new Set());
      return;
    }
    let cancelled = false;
    (async () => {
      const checks = parentCombos.map(c => {
        const filtersStr =
          `filters[REGESTXX]=ACTIVO` +
          `&filters[EMPNITXX]=${c.EMPNITPA}` +
          `&filters[AREAIDXX]=${c.AREAIDPA}` +
          `&filters[SERIEIDX]=${c.SERIEIPA}` +
          `&filters[TIPOIDXX]=${c.TIPOIDPA}` +
          `&filtersJson[JSONMETX->CLIIDXXX]=${CLIIDXXX}` +
          `&filtersJsonEmpty[JSONMETX->DOCNROXX]=1`;
        return dispatch(
          trkgfileApiSlice.endpoints.getFilters.initiate(
            { filters: filtersStr, reports: false, page: 1, per_page: 1, sorts: "" },
            { forceRefetch: false }
          )
        ).unwrap()
          .then(res => ({ combo: c, hasData: (res?.data?.length ?? 0) > 0 }))
          .catch(() => ({ combo: c, hasData: false }));
      });
      const results = await Promise.all(checks);
      if (cancelled) return;
      const tipos = new Set();
      const series = new Set();
      results.forEach(({ combo, hasData }) => {
        if (!hasData) return;
        tipos.add(String(combo.TIPOIDPA));
        series.add(String(combo.SERIEIPA));
      });
      setExistingTipoIds(tipos);
      setExistingSerieIds(series);
    })();
    return () => { cancelled = true; };
  }, [parentCombos, CLIIDXXX, dispatch]);

  const filtersByFormInfo = useMemo(() =>
    `filtersIn[EMPNITXX]=${parentEmpnits}` +
    `&filtersIn[AREAIDXX]=${parentAreaids}` +
    `&filters[REGESTXX]=ACTIVO` +
    `&filtersIn[TIPOIDXX]=${parentTipoids}` +
    `&filtersJson[JSONMETX->CLIIDXXX]=${CLIIDXXX}` +
    `&filtersJsonEmpty[JSONMETX->DOCNROXX]=1`,
  [parentEmpnits, parentAreaids, parentTipoids, CLIIDXXX]);

  const parentEmpnitSet = useMemo(() => [...new Set(parents.map(r => r.EMPNITPA))], [parents]);

  const empresaOptions = useMemo(() => {
    if (!companysData?.data) return [];
    return companysData.data.filter(c => parentEmpnitSet.includes(String(c.EMPNITXX)));
  }, [companysData, parentEmpnitSet]);

  const areaOptions = useMemo(() => {
    if (!procesosData?.data) return [];
    const relevantParents = filterEmpresa
      ? parents.filter(r => String(r.EMPNITPA) === String(filterEmpresa))
      : parents;
    const ids = [...new Set(relevantParents.map(r => String(r.AREAIDPA)))];
    return procesosData.data.filter(a => ids.includes(String(a.AREAIDXX)));
  }, [procesosData, parents, filterEmpresa]);

  const tipoOptions = useMemo(() => {
    if (!tiposData?.data) return [];
    const relevantParents = parents.filter(r =>
      (!filterEmpresa || String(r.EMPNITPA) === String(filterEmpresa)) &&
      (!filterArea    || String(r.AREAIDPA) === String(filterArea)) &&
      (!filterSerie   || String(r.SERIEIPA) === String(filterSerie))
    );
    const ids = [...new Set(relevantParents.map(r => String(r.TIPOIDPA)))];
    return tiposData.data.filter(t => ids.includes(String(t.TIPOIDXX)));
  }, [tiposData, parents, filterEmpresa, filterArea, filterSerie]);

  const metadatoOptions = useMemo(() => {
    if (!metadatosData?.data) return [];
    const relevantParents = parents.filter(r =>
      (!filterEmpresa || String(r.EMPNITPA) === String(filterEmpresa)) &&
      (!filterArea    || String(r.AREAIDPA) === String(filterArea)) &&
      (!filterSerie   || String(r.SERIEIPA) === String(filterSerie)) &&
      (!filterTipo    || String(r.TIPOIDPA) === String(filterTipo))
    );
    const ids = [...new Set(relevantParents.map(r => String(r.METIDXXX)))];
    return metadatosData.data.filter(m => ids.includes(String(m.METIDXXX)));
  }, [metadatosData, parents, filterEmpresa, filterArea, filterSerie, filterTipo]);

  const filters = useSelector(getFiltersTkr);

  useEffect(() => {
    showBySeridxxx(0);
  // eslint-disable-next-line
  }, [parents]);

  const { data, isLoading, isFetching } = useGetFiltersQuery({
    filters,
    reports: reports,
    page,
    per_page: perPage,
    sorts,
  });

  const seriesFromQuery = useMemo(() => {
    if (!seriesData?.data) return [];
    return seriesData.data.filter(s => existingSerieIds.has(String(s.SERIEIDX)));
  }, [seriesData, existingSerieIds]);

  const tipoOptionsFromData = useMemo(() => {
    if (!tiposData?.data) return [];
    return tiposData.data.filter(t => existingTipoIds.has(String(t.TIPOIDXX)));
  }, [tiposData, existingTipoIds]);

  useEffect(() => {
    if (data && data?.data?.length > 0 && !reports) {
      const dataTkring = data.data.map((row) => {
        if (row.JSONMETX?.CLIIDXXX) {
          dispatch(setCliidxx(row.JSONMETX.CLIIDXXX))
        }
        switch (row.TYPEXXXX) {
          case "application/pdf":
            return { ...row, imgfilex: "images/Icon-PDF.png" };
          case "image/png":
          case "image/jpeg":
          case "image/jpg":
            let nomFile = row.PATHFILX.split("/").at(-1);
            let fileprev = nomFile.split(".").at(0) + `-prev.${nomFile.split(".").at(1)}`;
            let imagePrev = row.DOCDURLX.replace(nomFile, fileprev);
            return { ...row, imgfilex: "images/file-earmark-image.svg", IMGPREVX: imagePrev };
          case "text/xml":
          case "application/vnd.ms-excel":
          case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
            return { ...row, imgfilex: "images/icon-excel.png" };
          case "docx":
            return { ...row, imgfilex: "images/icon-microsoft-word.png" };
          case "video/mp4":
          case "audio/mpeg":
            return { ...row, imgfilex: "images/file-video.svg" };
          case "text/plain":
            return { ...row, imgfilex: "images/filetype-txt.svg" };
          default:
            return { ...row, imgfilex: "images/default-ext.svg" };
        }
      });
      const dataarr = data.data.map((rows, key) => {
        return (key = false);
      });
      setSelAllChecked(dataarr);
      const dataFilter = dataTkring.filter((row) => {
        let retorno = true;
        if (row.AREAIDXX === 116) {
          retorno = validateExpiredDocuments(row);
        }
        return retorno;
      });
      if (data.meta.current_page > 1) {
        setDatatkr((prevdata) => prevdata.concat(dataFilter));
      } else {
        setDatatkr(dataFilter);
      }
      setChecSelc([]);
      setAllChecked(false);
    } else {
      setDatatkr([]);
    }
    // eslint-disable-next-line
  }, [data, dispatch]);

  const validateExpiredDocuments = (row) => {
    const FECINICI = new Date();
    const FECHAFIN = row.JSONMETX["FECHAFIN"] ? new Date(`${row.JSONMETX["FECHAFIN"]}T23:59:00`) : FECINICI;
    return FECHAFIN >= FECINICI;
  }


  const handleFiltrar = () => {
    dispatch(setCustomFilters({ ...customFilters, page: 1 }));
    let filts = `filters[REGESTXX]=ACTIVO&filtersJson[JSONMETX->CLIIDXXX]=${CLIIDXXX}&filtersJsonEmpty[JSONMETX->DOCNROXX]=1`;
    filts += filterEmpresa ? `&filters[EMPNITXX]=${filterEmpresa}` : `&filtersIn[EMPNITXX]=${parentEmpnits}`;
    filts += filterArea    ? `&filters[AREAIDXX]=${filterArea}`    : `&filtersIn[AREAIDXX]=${parentAreaids}`;
    if (filterSerie) filts += `&filters[SERIEIDX]=${filterSerie}`;
    filts += filterTipo    ? `&filters[TIPOIDXX]=${filterTipo}`    : `&filtersIn[TIPOIDXX]=${parentTipoids}`;
    if (filterMetadato && filterMetaVal) {
      filts += `&filtersJson[JSONMETX->${filterMetadato}]=${filterMetaVal}`;
    }
    dispatch(setFiltersTkr(filts));
  };

  const handleSubmit = (event) => {
    setFileParents((checSelc.map((row) => {
      return {
        IDARCHXX: row.IDARCHXX,
        METAKEYX: row.TIPODESX,
        METAVALX: row.JSONMETX[(
          parents.filter((parent) => {
            return parent.AREAIDPA.toString() === row.AREAIDXX.toString()
              && parent.SERIEIPA.toString() === row.SERIEIDX.toString()
              && parent.TIPOIDPA.toString() === row.TIPOIDXX.toString();
          })[0].METIDXXX
        )]??"SIN METADATO"
      }
    })));
    onClose(false);
  };

  const prevpage = (page) => {
    dispatch(setCustomFilters({ ...customFilters, page }));
  };

  const showBySeridxxx = (SERIEIDX) => {
    dispatch(setCustomFilters({ ...customFilters, page: 1 }));
    setSelectedKey(parseInt(SERIEIDX));
    if (parseInt(SERIEIDX) !== 0) {
      const matchingParent = parents.find(r => String(r.SERIEIPA) === String(SERIEIDX));
      if (matchingParent) {
        setFilterEmpresa(String(matchingParent.EMPNITPA));
        setFilterArea(String(matchingParent.AREAIDPA));
        setFilterSerie(String(SERIEIDX));
      }
      let filts = `filters[REGESTXX]=ACTIVO&filtersJson[JSONMETX->CLIIDXXX]=${CLIIDXXX}&filtersJsonEmpty[JSONMETX->DOCNROXX]=1` +
        `&filters[EMPNITXX]=${matchingParent?.EMPNITPA ?? ""}` +
        `&filters[AREAIDXX]=${matchingParent?.AREAIDPA ?? ""}` +
        `&filters[SERIEIDX]=${SERIEIDX}` +
        `&filtersIn[TIPOIDXX]=${parentTipoids}`;
      dispatch(setFiltersTkr(filts));
    } else {
      setFilterEmpresa(""); setFilterArea(""); setFilterSerie("");
      dispatch(setFiltersTkr(filtersByFormInfo));
    }
  };

  const viewFiles = (dataRow) => {
    if (dataRow && typeof dataRow === 'object' && 'TYPEXXXX' in dataRow && dataRow.TYPEXXXX === 'application/pdf') {
      const jsonData = JSON.stringify({
        url: dataRow.DOCDURLX,
        pEMPNITXX: dataRow.EMPNITXX,
        pAREAIDXX: dataRow.AREAIDXX,
        pSERIEIDX: dataRow.SERIEIDX,
        pTIPOIDXX: dataRow.TIPOIDXX
      });
      const encryptedData = CryptoJS.AES.encrypt(jsonData, 'GenioVisorPDF').toString();
      const urlBase = `/#/visor/${encodeURIComponent(encryptedData)}`;
      window.open(urlBase, '_blank');
    } else {
      window.open(dataRow.DOCDURLX, '_blank');
    }
  };

  const viewMetada = (meta, metaMaq) => {
    setMetadaSelc(meta);
    setMetadaMaqSelc(metaMaq);
    setOpMetada(true);
  };
  const viewLine = (dataline) => {
    setLineData(dataline);
    setLinetime(true);
  };

  const selChecked = (xKey, e) => {
    let arrchck = [];
    let data = JSON.parse(e.target.value);
    let value = data.IDARCHXX.toString();
    setAllChecked(false);
    const valArr = selAllChecked.map((rows, key) => {
      if (xKey === key) {
        return (key = !rows);
      } else {
        return (key = rows);
      }
    });
    if (checSelc.length > 0) {
      arrchck = checSelc.filter((itm) => {
        return itm.IDARCHXX.toString() !== value;
      });
      if (e.target.checked) {
        arrchck.push(data);
      }
    } else {
      arrchck.push(data);
    }
    setChecSelc(arrchck);
    setSelAllChecked(valArr);
  };

  const selAllCheck = () => {
    if (checSelc.length > 0) {
      setChecSelc([]);
    }
    const band = !AllChecked;
    setAllChecked(!AllChecked);
    const dataarr = dataTkr.map((rows, key) => {
      if (band) {
        setChecSelc((idarch) => [...idarch, rows]);
      } else {
        setChecSelc([]);
      }
      return (key = band);
    });
    setSelAllChecked(dataarr);
  };

  const viewImages = (dataRow) => {
    let filts = '';
    if (Object.entries(dataRow.JSONMETX).length > 0) {
      for (let val in dataRow.JSONMETX) {
        if (val === "DOCNROXX" && typeof dataRow.JSONMETX[val] === 'object') {
          let nDocNros = dataRow.JSONMETX[val];
          for (let nDo of nDocNros) {
            filts += `filters[JSONMETX][->][${val}]=${nDo}&`
          };
        } else {
          if (dataRow.JSONMETX[val] !== "") {
            filts += `filters[JSONMETX][->][${val}]=${dataRow.JSONMETX[val]}&`
          }
        }
      }
      filts += "filters[REGESTXX]=ACTIVO&filters[TYPEXXXX][IN]=image/png,image/jpg,image/jpeg";
    }
    setJsonFilters(filts)
    setModalView(true);
    setCurrentImage(dataRow.DOCDURLX);
    setDataEdit(dataRow);
  };

  return (
    <>
      <Row key="options">
        <ButtonGroup aria-label="Tipos">
          <Button
            variant="primary"
            className={selectedKey===0?"button-group-selected-item":"button-group-item"}
            onClick={(e) => showBySeridxxx(0)}
          >GENERAL</Button>
          {seriesFromQuery.map((item, index) => (
            <Button
              key={index}
              variant="primary"
              className={selectedKey===parseInt(item.SERIEIDX)?"button-group-selected-item":"button-group-item"}
              onClick={(e) => showBySeridxxx(item.SERIEIDX)}
            >
              {item.SERIEDES}
            </Button>
          ))}
        </ButtonGroup>
      </Row>

      <Row className="mt-3 mb-2 g-2 align-items-end">
        <Col md={3}>
          <Form.Label>Empresa</Form.Label>
          <Form.Select
            value={filterEmpresa}
            onChange={e => {
              setFilterEmpresa(e.target.value);
              setFilterArea(""); setFilterSerie(""); setFilterTipo(""); setFilterMetadato(""); setFilterMetaVal("");
            }}
            disabled={selectedKey !== 0}
          >
            <option value="">[TODAS]</option>
            {empresaOptions.map(c => (
              <option key={c.EMPNITXX} value={c.EMPNITXX}>{c.EMPDESXX}</option>
            ))}
          </Form.Select>
        </Col>
        <Col md={3}>
          <Form.Label>Proceso</Form.Label>
          <Form.Select
            value={filterArea}
            onChange={e => {
              setFilterArea(e.target.value);
              setFilterSerie(""); setFilterTipo(""); setFilterMetadato(""); setFilterMetaVal("");
            }}
            disabled={selectedKey !== 0}
          >
            <option value="">[TODOS]</option>
            {areaOptions.map(a => (
              <option key={a.AREAIDXX} value={a.AREAIDXX}>{a.AREADESX}</option>
            ))}
          </Form.Select>
        </Col>
        <Col md={3}>
          <Form.Label>Serie</Form.Label>
          <Form.Select
            value={filterSerie}
            onChange={e => {
              setFilterSerie(e.target.value);
              setFilterTipo(""); setFilterMetadato(""); setFilterMetaVal("");
            }}
            disabled={selectedKey !== 0}
          >
            <option value="">[TODAS]</option>
            {seriesFromQuery.map(s => (
              <option key={s.SERIEIDX} value={s.SERIEIDX}>{s.SERIEDES}</option>
            ))}
          </Form.Select>
        </Col>
        <Col md={3}>
          <Form.Label>Tipo Documental</Form.Label>
          <Form.Select
            value={filterTipo}
            onChange={e => {
              setFilterTipo(e.target.value);
              setFilterMetadato(""); setFilterMetaVal("");
            }}
          >
            <option value="">[TODOS]</option>
            {tipoOptions.filter(t => tipoOptionsFromData.some(td => td.TIPOIDXX === t.TIPOIDXX)).map(t => (
              <option key={t.TIPOIDXX} value={t.TIPOIDXX}>{t.TIPODESX}</option>
            ))}
          </Form.Select>
        </Col>
      </Row>
      <Row className="mb-3 g-2 align-items-end">
        <Col md={3}>
          <Form.Label>Metadato</Form.Label>
          <Form.Select
            value={filterMetadato}
            onChange={e => { setFilterMetadato(e.target.value); setFilterMetaVal(""); }}
          >
            <option value="">[SELECCIONE]</option>
            {metadatoOptions.map(m => (
              <option key={m.METIDXXX} value={m.METIDXXX}>{m.METDESXX}</option>
            ))}
          </Form.Select>
        </Col>
        {filterMetadato !== "" && (
          <Col md={3}>
            <Form.Label>Nombre del metadato</Form.Label>
            <Form.Control
              type="text"
              value={filterMetaVal}
              onChange={e => setFilterMetaVal(e.target.value)}
              placeholder="Ingrese valor..."
            />
          </Col>
        )}
        <Col md={filterMetadato !== "" ? 3 : 6} className="d-flex align-items-end">
          <Button variant="secondary" onClick={handleFiltrar} className="w-100">
            FILTRAR
          </Button>
        </Col>
      </Row>
      {/* ===== Fin panel de filtros ===== */}

      <Row key="select_all_1">
        <Col>
          <Form.Check label={"Seleccionar Todos"} onChange={() => selAllCheck()} checked={AllChecked} />
        </Col>
      </Row>
      <br></br>
      <Row key="pages">
        <Col className="d-flex justify-content-end">
          <span>Items por Pagina: {dataTkr.length}</span>
        </Col>
      </Row>
      <Row key="file_container">
        {(isLoading || isFetching) && page === 1 ? (
          <Loadingx />
        ) : dataTkr.length > 0 ? (
          <div id="scrollableDiv" style={{ height: "800px", overflowY: "scroll" }}>
            <InfiniteScroll
              dataLength={dataTkr.length}
              hasMore={data.meta.current_page < data.meta.last_page}
              next={() => {prevpage(page + 1)}}
              loader={<Loadingx heigth={100} width={100} />}
              scrollableTarget="scrollableDiv"
            >
              {dataTkr.map((row, key) => {
                return (
                  <div
                    key={`pr${key}`}
                    className="p-3 col-7 col-md-4 col-lg-3 "
                    style={{ display: "inline-block" }}
                  >
                    <Card className="shadow rounded p-3" border="light" style={{ width: "15rem" }}>
                      <Container fluid>
                        <Row key={`pr-file-${key}`}>
                          <Col>
                            {row.TYPEXXXX === "image/png" ||
                              row.TYPEXXXX === "image/jpeg" ||
                              row.TYPEXXXX === "image/jpg" ? (
                              <img
                                variant="top"
                                src={`${process.env.REACT_APP_VISOR_WEB}/${row.imgfilex}`}
                                width="25"
                                height="35"
                                alt="imagen-files"
                              />
                            ) : (
                              <img
                                variant="top"
                                src={`${process.env.REACT_APP_VISOR_WEB}/${row.imgfilex}`}
                                width="50"
                                alt="imagen-files"
                              />
                            )}
                          </Col>
                          <Col className="d-grid justify-content-end">
                            <Form.Check
                              value={JSON.stringify(row)}
                              onChange={(e) => selChecked(key, e)}
                              checked={selAllChecked[key]}
                            />
                          </Col>
                        </Row>
                        <Row key={`rw-file-${key}`}>
                          <Card.Body>
                            <Container>
                              {row.TYPEXXXX === "image/png" ||
                                row.TYPEXXXX === "image/jpeg" ||
                                row.TYPEXXXX === "image/jpg" ? (
                                <Row>
                                  <Col className="d-grid justify-content-center">
                                    <img variant="top" src={`${row.IMGPREVX}`} alt="No se encontro Prev-Imagen" />
                                  </Col>
                                </Row>
                              ) : (
                                ""
                              )}
                              <Row key={`des${key}`}>
                                <Col className="col-12 text-doc p-0">
                                  <strong>TIPO</strong> : {row.TIPODESX}
                                </Col>
                              </Row>
                              {Object.keys(row.METADATX).map((item, key) => {
                                if (key <= 3) {
                                  let typeMet = "";
                                  typeof row.METADATX[item] === "object" && row.METADATX[item] !== null
                                    ? (typeMet = row.METADATX[item].join(", "))
                                    : (typeMet = row.METADATX[item]);
                                  return (
                                    <Row key={key}>
                                      <Col className="col-12 text-doc p-0">
                                        <strong>{item}</strong> : {typeMet}
                                      </Col>
                                    </Row>
                                  );
                                } else {
                                  return "";
                                }
                              })}
                              <Row key={key}>
                                <Col className="col-12 text-doc p-0">
                                  <strong>FECHA</strong> : {row.REGFECXX} / {row.REGHORXX}
                                </Col>
                              </Row>
                            </Container>
                          </Card.Body>
                        </Row>
                        <Row key={`pr-opts-${key}`}>
                          <Col>
                            <img
                              onClick={() => viewLine(row)}
                              src={`${process.env.REACT_APP_VISOR_WEB}/images/icon-timeline.png`}
                              height={30}
                              alt="time line"
                              style={{ cursor: "pointer" }}
                            />
                          </Col>
                          <Col>
                            <img
                              onClick={() => viewMetada(row.METADATX, row.JSONMETX)}
                              variant="top"
                              src={`${process.env.REACT_APP_VISOR_WEB}/images/icon-info.png`}
                              height={30}
                              alt="info"
                              style={{ cursor: "pointer" }}
                            />
                          </Col>
                          {row.TYPEXXXX === "image/png" ||
                            row.TYPEXXXX === "image/jpeg" ||
                            row.TYPEXXXX === "image/jpg" ? (
                            <Col>
                              <img
                                onClick={() => viewImages(row)}
                                variant="top"
                                src={`${process.env.REACT_APP_VISOR_WEB}/images/icon-view.png`}
                                height={30}
                                alt="view"
                                style={{ cursor: "pointer" }}
                              />
                            </Col>
                          ) : (
                            <Col>
                              <img
                                onClick={() => viewFiles(row)}
                                variant="top"
                                src={`${process.env.REACT_APP_VISOR_WEB}/images/icon-view.png`}
                                height={30}
                                alt="view"
                                style={{ cursor: "pointer" }}
                              />
                            </Col>
                          )
                          }
                        </Row>
                      </Container>
                    </Card>
                  </div>
                );
              })}
            </InfiniteScroll>
          </div>
        ) : (
          ""
        )}
      </Row>
      {opMetada && (
        <Metadatx
          opMetada={opMetada}
          setOpMetada={setOpMetada}
          metadaSelc={metadaSelc}
          setMetadaSelc={setMetadaSelc}
          metadaMaqSelc={metadaMaqSelc}
        />
      )}
      {linetime && (
        <Linetime linetime={linetime} setLinetime={setLinetime} lineData={lineData} setLineData={setLineData} />
      )}
      {modalView && jsonFilters && (<Modaview modalView={modalView} setModalView={setModalView} jsonFilters={jsonFilters} currentImage={currentImage} dataEdit={dataEdit} />)}
      <br></br>
      <Row key="select_all_2">
        <Col>
          <Form.Check label={"Seleccionar Todos"} onChange={() => selAllCheck()} checked={AllChecked} />
        </Col>
      </Row>
      <Row md={12} className="mt-3">
        <Col className="offset-10" md={1}>
          <Button onClick={handleSubmit}>Guardar</Button>
        </Col>
      </Row>
    </>
  )
};

export default Selparxx;
